import React from 'react';
import { Link } from 'react-router-dom';
import PermissionsGate from '../../utils/permissionGate';
import { SP_PASS } from '../../utils/Constants';

const CourseActionButtons = ({ row, setCourseId, setTypeOfCourse, handleCopyCourse, handleDeleteCourse }) => {
    const renderCopyButton = () => {
        const buttonConfig = {
            scheduled: {
                title: "Copy Course AMI (Academic)",
                icon: "fas fa-copy",
                modal: "#copyAcademicAMIModal",
                onClick: () => {
                    setCourseId(row.id);
                    setTypeOfCourse(row.type);
                }
            },
            selfplaced: {
                title: "Copy SLP AMI Course",
                icon: "far fa-copy",
                modal: "#copyCourse",
                onClick: () => {
                    setCourseId(row.id);
                    setTypeOfCourse(row.type);
                }
            },
            shortcourse: {
                title: "Copy To Future Date",
                icon: "far fa-copy",
                modal: "#copyCourse",
                onClick: () => handleCopyCourse(row)
            },
            "short course": {
                title: "Copy To Future Date",
                icon: "far fa-copy",
                modal: "#copyCourse",
                onClick: () => handleCopyCourse(row)
            }
        };

        const config = buttonConfig[row.subject_type];
        
        return config && (
            <PermissionsGate scopes={["cadd"]} errorProps={{ disabled: true }}>
                <button
                    className="btn btn-primary rounded-circle"
                    title={config.title}
                    data-toggle="modal"
                    data-target={config.modal}
                    onClick={config.onClick}
                >
                    <i className={config.icon}></i>
                </button>
            </PermissionsGate>
        );
    };

    return (
        <>
            {renderCopyButton()}
            
            <Link
                className="btn btn-primary rounded-circle"
                to={{
                    pathname: `https://student.myaie.ac/courseinfo/${row.qualification_id}/subject/${row.intakeID}/${SP_PASS}`,
                }}
                target="_blank"
                title="Student View"
            >
                <i className="fal fa-eye"></i>
            </Link>
            
            <PermissionsGate scopes={["cdelete"]} errorProps={{ disabled: true }}>
                <button 
                    className="btn btn-danger rounded-circle" 
                    title="Delete"
                    onClick={() => handleDeleteCourse(row.id)}
                >
                    <i className="fal fa-trash-alt"></i>
                </button>
            </PermissionsGate>
        </>
    );
};

export default CourseActionButtons;